import Scraping from './scraping.vue'
import UserTable from './user-table.vue'
import Tasks from './tasks.vue'
import System from './system.vue'
import Pulse from './pulse.vue'
import Beta from './beta.vue'
import Mongo from './mongo'
import Weaviate from './weaviate'
import PulseDashboard from './pulse-dashboard.vue'
import TestSkills from './test-skills'
import TestAgents from './test-agents'
import TestTools from './test-tools'

const __default__ = {
  data() {
    return {
      active: 'system',
      tabs: [
        {value: 'system', title: 'System'},
        {value: 'pulse', title: 'Pulse'},
        {value: 'beta', title: 'Beta Users'},
        {value: 'scraping', title: 'Scraping'},
        {value: 'user-table', title: 'Users'},
        {value: 'tasks', title: 'Tasks'},
        {value: 'mongo', title: 'Mongo'},
        {value: 'weaviate', title: 'Weaviate'},
        {value: 'pulse-dashboard', title: 'Pulse Dashboard'},
        {value: 'test-skills', title: 'Test Skills'},
        {value: 'test-agents', title: 'Test Agents'},
        {value: 'test-tools', title: 'Test Tools'},
      ]
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'admin',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { Scraping, UserTable, Tasks, System, Pulse, Beta, get Mongo() { return Mongo }, get Weaviate() { return Weaviate }, PulseDashboard, get TestSkills() { return TestSkills }, get TestAgents() { return TestAgents }, get TestTools() { return TestTools } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})